var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

function setup(hero) {
  if (hero.getAttribute('data-cda-hero-bound') === '1') return;
  hero.setAttribute('data-cda-hero-bound', '1');

  var track = hero.querySelector('[data-cda-hero-track]');
  var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-cda-hero-slide]'));
  var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-cda-hero-dot]'));
  var current = 0;
  var holds = { focus: false, offscreen: false, hidden: false };

  var jumping = null;
  var jumpTimer = null;

  function goTo(index) {
    var total = slides.length;
    var target = (index + total) % total;
    jumping = target;
    clearTimeout(jumpTimer);
    // segurança: se o navegador não avisar o fim da rolagem, libera depois de um tempo
    jumpTimer = setTimeout(function() { jumping = null; }, 900);
    track.scrollTo({ left: target * track.clientWidth, behavior: REDUCED.matches ? 'auto' : 'smooth' });
    // marca já, sem esperar a rolagem terminar: a barra do novo atual começa do zero
    mark(target);
  }

  function mark(index, force) {
    if (!force && index === current) return;
    current = index;
    dots.forEach(function(dot, i) {
      if (i === index) {
        dot.setAttribute('aria-current', 'true');
        // reinicia a animação da barra (tirar e pôr o atributo no mesmo quadro não basta)
        var fill = dot.querySelector('.cda-hero__dot-fill');
        fill.style.animation = 'none';
        void fill.offsetWidth;
        fill.style.animation = '';
      } else {
        dot.removeAttribute('aria-current');
      }
    });
    slides.forEach(function(slide, i) {
      if (i === index) slide.removeAttribute('inert');
      else slide.setAttribute('inert', '');
    });
  }

  function refreshPause() {
    var paused = holds.focus || holds.offscreen || holds.hidden;
    hero.classList.toggle('is-paused', paused);
  }

  function setStopped(stopped) {
    hero.classList.toggle('is-stopped', stopped);
  }

  // fim da barra do atual = hora de passar para o próximo
  hero.addEventListener('animationend', function(event) {
    if (event.animationName !== 'cda-hero-progress') return;
    if (hero.classList.contains('is-stopped')) return;
    goTo(current + 1);
  });

  // arrastou com o dedo (ou rolou com o trackpad): o indicador acompanha
  var frame = null;
  track.addEventListener('scroll', function() {
    if (frame) return;
    frame = requestAnimationFrame(function() {
      frame = null;
      var index = Math.round(track.scrollLeft / track.clientWidth);
      if (jumping !== null) {
        // rolagem do próprio carrossel: só libera quando chega ao destino
        if (index === jumping && Math.abs(track.scrollLeft - index * track.clientWidth) < 2) jumping = null;
        return;
      }
      if (index !== current && index >= 0 && index < slides.length) mark(index);
    });
  }, { passive: true });

  track.addEventListener('scrollend', function() { jumping = null; });

  hero.querySelector('[data-cda-hero-prev]').addEventListener('click', function() { goTo(current - 1); });
  hero.querySelector('[data-cda-hero-next]').addEventListener('click', function() { goTo(current + 1); });
  dots.forEach(function(dot, i) {
    dot.addEventListener('click', function() { goTo(i); });
  });

  // setas do teclado com o foco dentro do banner
  hero.addEventListener('keydown', function(event) {
    if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(current - 1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); goTo(current + 1); }
  });

  // só foco de teclado pausa (quem navega com Tab precisa de tempo); o foco que o clique de
  // mouse deixa nas setas e indicadores não conta
  hero.addEventListener('focusin', function(event) {
    holds.focus = event.target.matches(':focus-visible');
    refreshPause();
  });
  hero.addEventListener('focusout', function(event) {
    if (hero.contains(event.relatedTarget)) return;
    holds.focus = false;
    refreshPause();
  });

  if ('IntersectionObserver' in window) {
    hero._cdaObserver = new IntersectionObserver(function(entries) {
      holds.offscreen = !entries[0].isIntersecting;
      refreshPause();
    }, { threshold: 0.25 });
    hero._cdaObserver.observe(hero);
  }

  hero._cdaVisibility = function() {
    holds.hidden = document.hidden;
    refreshPause();
  };
  document.addEventListener('visibilitychange', hero._cdaVisibility);

  // a janela mudou de largura: mantém o banner atual encaixado
  hero._cdaResize = function() {
    track.scrollTo({ left: current * track.clientWidth, behavior: 'auto' });
  };
  window.addEventListener('resize', hero._cdaResize);

  // os outros banners carregam depois da página (sem disputar com o primeiro), para não
  // aparecerem em branco na primeira troca
  var eager = function() {
    hero.querySelectorAll('img[loading="lazy"]').forEach(function(img) { img.loading = 'eager'; });
  };
  if (document.readyState === 'complete') eager();
  else window.addEventListener('load', eager, { once: true });

  setStopped(REDUCED.matches);
  mark(0, true);
}

function teardown(hero) {
  if (hero._cdaObserver) hero._cdaObserver.disconnect();
  if (hero._cdaVisibility) document.removeEventListener('visibilitychange', hero._cdaVisibility);
  if (hero._cdaResize) window.removeEventListener('resize', hero._cdaResize);
}

document.addEventListener('turbolinks:load', function() {
  document.querySelectorAll('[data-cda-hero]').forEach(setup);
});

// antes de guardar a página no cache do Turbolinks: solta os ouvintes globais e volta ao estado
// inicial, para a cópia guardada não voltar com a barra no meio
document.addEventListener('turbolinks:before-cache', function() {
  document.querySelectorAll('[data-cda-hero]').forEach(function(hero) {
    teardown(hero);
    hero.removeAttribute('data-cda-hero-bound');
    hero.classList.remove('is-paused', 'is-stopped');
    var track = hero.querySelector('[data-cda-hero-track]');
    if (track) track.scrollLeft = 0;
  });
});
